export default "__VITE_ASSET__CmRxQfd5__"